import { CorporateBankAccountCalculator } from "@component/CorporateBankAccount/Calculator/CorporateBankAccountCalculator";
import { LandingBottom } from "@landing/components/LandingBottom";
import { LandingGyikBig } from "@landing/components/LandingGyikBig";
import type { ReactNode } from "react";
import React from "react";

/**
 * @Routing
 *
 * @title "Vállalkozói bankszámla kereső"
 * @description "A legfontosabb, hogy tisztában legyünk cégünk szokásaival, így könnyen megtaláljuk a legmegfelelőbb és legolcsóbb vállalkozói bankszámlát"
 * @route "/vallalati/bankszamla/"
 */
export default class Landing extends React.PureComponent {
	public render(): ReactNode {
		return (
			<>
				<CorporateBankAccountCalculator />
				<LandingGyikBig
					title="Gyakran ismételt kérdések"
					questions={{
						"Mi alapján érdemes bankot választani?": (
							<p>
								A legtöbb cég a lehető legolcsóbban szeretné a bankolást megúszni. A kisebb bankok
								általában olcsóbbak. Azt viszont ne feledjük, hogy a bankok közötti pénzmozgások
								általában drágábbak, mintha bankon belül történnek. Egy nagyobb méretű banknál több az
								esély arra, hogy üzletfeleink is vezetnek ott számlát, így sokat spórolhatunk az
								átutalásokon. Csakhogy a nagyobb bank általában magasabb díjakat alkalmaz a
								kicsinél.Természetesen a költségek kiemelten fontosak, ugyanakkor a banknál elérhető
								szolgáltatások köre sem elhanyagolható. Ezért számlanyitást megelőzően érdemes alaposan
								tanulmányozni a bank által kínált szolgáltatás-palettát is.
							</p>
						),
						"Mitől függ, hogy melyik a legjobb bankszámla cégemnek?": (
							<p>
								Egyetlen dologtól, mégpedig a cég bankszámla használati szokásaitól. Egy induló
								vállalkozásnál, amikor még kisebb a forgalom, akkor leginkább a számlavezetési díj a
								legfontosabb költség. Nagyobb, régóta működő vállalkozásnál már a tranzakciós költségek
								a meghatározóak. A legfontosabb, hogy tisztában legyünk cégünk szokásaival, így könnyen
								megtaláljuk a legmegfelelőbbet a banki ajánlatok között.
							</p>
						),
						"Milyen céges bankkártyát érdemes választani?": (
							<p>
								Az elektronikus bankkártyák jellemzően olcsóbbak, mint dombornyomott társaik. Így
								minimális ráfordítás mellett élvezhető a bankkártyák minden előnye. Dombornyomott
								kártyát azoknak érdemes választani, akik az átlagosnál többet utaznak külföldre. Ezek a
								kártyák szélesebb körben használhatóak, mint elektronikus társaik, továbbá nagy előnyük,
								hogy a legtöbb bank a bankkártya elvesztésekor sürgősségi szolgáltatásokat
								(kártyapótlás, készpénzfelvétel) biztosít külföldön.
							</p>
						),
						"Milyen bankszámlát válasszak induló vállalkozásként?": (
							<p>
								Több bank is kínál olyan számlacsomagot, amit kizárólag induló vállalkozások vehetnek
								igénybe. Ezek díjszabását igyekeznek a pénzintézetek úgy kialakítani, hogy azok
								lehetőség szerint gazdaságos pénzügyi megoldást jelentsenek. Arra viszont ügyeljünk,
								hogy egy induló vállalkozásnál alacsony forgalommal és kevés tranzakcióval kalkulálnak a
								bankok, ami a díjszabásban is tetten érhető. Így, ha cégünk bankszámla használati
								szokásai merőben másak, akkor ne csak a kezdő vállalkozásoknak kínált lehetőségek között
								keresgéljünk.
							</p>
						),
						"Milyen bankszámlát válasszak, ha cégem speciális tevékenységet végez?": (
							<p>
								Bizonyos szakmák képviselőinek (pl. könyvelők, jogászok, gyógyszerészek) a bankok
								speciális számlacsomagokat alakítottak ki. Hasonló a helyzet itt is, mint az induló
								vállalkozások esetében. Feltétlenül számoljunk ezekkel a lehetőségekkel is, de ne csak
								ezek között keresgéljünk. Előfordulhat, hogy cégünk bankszámla használati szokásai
								mellett kedvezőbb feltételekkel vehetünk igénybe egy normál bankszámlát.
							</p>
						),
						"Érdemes-e devizaszámlát nyitnom?": (
							<p>
								Azért még nem érdemes egy devizaszámlát fenntartani, hogy nagy ritkán egy-egy kisebb
								összegű devizautalás érkezik, vagy kerül elutalásra. Ezek fogadására, indítására a
								vállalkozás forint pénzforgalmi számlája is tökéletesen alkalmas. Jelentős
								devizaforgalom mellett már más a helyzet. A legtöbb esetben a számla fenntartásának díja
								van, de akad néhány bank, ahol díjmentesen vagy kedvezményesen vehető igénybe, ha forint
								számlával is rendelkezik a vállalkozás az adott pénzintézetnél. A számlavezetési díjon
								túl az átutalási költségekre, valamint a bank által alkalmazott árfolyamokra figyeljünk
								még feltétlenül.
							</p>
						),
					}}
				/>
				<LandingBottom tags="nhp,vallalati-hitel,faktoring" />
			</>
		);
	}
}
